import { useRef, useState } from 'react';
import { Map, Upload } from 'lucide-react';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

// Owner / Manager / Assistant Manager upload one floor plan per property; field scoops show the icon once a file exists.
export default function FloorPlanUpload({ propertyId, floorPlanUrl, readOnly = false }) {
  const [url, setUrl] = useState(floorPlanUrl || ''), [busy, setBusy] = useState(false), [error, setError] = useState(''), [show, setShow] = useState(false);
  const input = useRef(null);
  const upload = async (file) => {
    if (!file) return;
    setBusy(true); setError('');
    try {
      const body = new FormData(); body.append('file', file);
      const res = await fetch(`${API}/api/properties/${propertyId}/floor-plan`, { method: 'POST', credentials: 'include', body });
      const data = await res.json();
      if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Upload failed.');
      setUrl(`${data.floor_plan_url}?v=${Date.now()}`); toast.success('Floor plan uploaded · visible to field staff scoops');
    } catch (e) { setError(e.message); toast.error(e.message); }
    finally { setBusy(false); if (input.current) input.current.value = ''; }
  };
  return <section className="border-t border-zinc-700 pt-4 space-y-2" data-testid="floor-plan-upload">
    <div className="flex flex-wrap items-center justify-between gap-2">
      <h3 className="text-sm font-bold text-[#C9A962] flex items-center gap-1.5"><Map size={15}/>Structure &amp; Floor Plan</h3>
      <div className="flex gap-2">
        {url && <button type="button" onClick={() => setShow(s => !s)} className="text-xs border border-zinc-600 rounded px-2 py-1 hover:bg-zinc-800" data-testid="floor-plan-preview-toggle">{show ? 'Hide' : 'View'} floor plan</button>}
        {!readOnly && <><input ref={input} type="file" accept="image/png,image/jpeg,image/webp,application/pdf" className="hidden" onChange={e => upload(e.target.files?.[0])} data-testid="floor-plan-file-input"/>
          <button type="button" disabled={busy} onClick={() => input.current?.click()} className="text-xs bg-[#FFD60A] text-black rounded px-2 py-1 flex items-center gap-1 disabled:opacity-40" data-testid="floor-plan-upload-button"><Upload size={13}/>{busy ? 'Uploading…' : url ? 'Replace floor plan' : 'Upload floor plan'}</button></>}
      </div>
    </div>
    <p className="text-[11px] text-zinc-400" data-testid="floor-plan-status">{url ? 'Floor plan on file · field staff see the floor-plan icon next to this property.' : 'No floor plan uploaded yet · PNG, JPG, WEBP or PDF up to 8 MB.'}</p>
    {error && <p role="alert" className="text-xs text-red-300" data-testid="floor-plan-error">{error}</p>}
    {show && url && <img src={`${API}${url}`} alt="Property floor plan" className="w-full max-w-xl rounded border border-zinc-700 bg-black" data-testid="floor-plan-preview"/>}
  </section>;
}
